<div class="flx-modal" role="dialog" aria-modal="true">
    <div class="flx-modal__header">
        <div class="with-desc">
            <h2 id="title_PlannerAutoAssign">{{translate?.general.buttons.autoAssign.singular}} {{translate?.task.fields.month.singular}}</h2>
            <span class="sub" id="label_PlannerAutoAssignSubtitle">{{translate?.general.buttons.select2.singular}} {{translate?.general.messages.aLower}} {{translate?.task.fields.month.singular | lowercase}} {{translate?.general.messages.toLower}} {{translate?.general.buttons.autoAssign.singular | lowercase}} {{translate?.general.status.unassigned.singular | lowercase}} {{translate?.setup.modules.types.fields.job.plural}}.</span>

        </div>
        <button class="icon-btn" aria-label="Close" id="btn_PlannerAutoAssignClose"
            [pTooltip]="translate?.general.buttons.close.singular" (click)="modalRef.hide()">
            <i class="fa-regular fa-xmark"></i>
        </button>
    </div>
    <div class="flx-modal__body mp-body">
        <label class="field-label mandatory" id="label_PlannerAutoAssignSelectMonth">{{translate?.general.buttons.select2.singular}} {{translate?.task.fields.month.singular}}</label>
        <div class="field-row field-row--single">
            <div>
                <p-calendar [showIcon]="true" appendTo="body" styleClass="cal-btn" view="month" placeholder="dd/mm/yy"
                    dateFormat="M yy" [ngModel]="selectedMonth" (ngModelChange)="onMonthChange($event)"
                    [ngClass]="{'ng-invalid ng-dirty ng-touched': monthTouched && !selectedMonth}"
                    [readonlyInput]="true" (onBlur)="onMonthBlur()">
                </p-calendar>
                <div class="p-error text-10" *ngIf="monthTouched && !selectedMonth">
                    <span>{{translate?.general.validationFE.requiredField}}</span>
                </div>
            </div>
        </div>
    </div>
    <div class="flx-modal__footer">
        <button class="custella-btn-white" id="btn_PlannerAutoAssignCancel"
            (click)="modalRef.hide()">{{translate?.general.buttons.cancel.singular}}</button>
        <p-button type="button" [label]="translate?.general.buttons.save.singular" id="btn_PlannerAutoAssignSave"
            (onClick)="onAutoAssignClick()" styleClass="h-32"></p-button>
    </div>
</div>